// @flow
import * as React from 'react';
import MultiImagePicker from 'components/MultiImagePicker';
import Field from './Field';

const MultiImagePickerField = ({
  name,
  label,
  description,
  allowVideo,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  allowVideo?: boolean
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <MultiImagePicker
        id={id}
        name={name}
        values={value}
        allowVideo={allowVideo}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default MultiImagePickerField;
